import { createSelector } from 'reselect';
import * as selectors from 'selectors/selectors';

export const projectHistorySelector = createSelector(
  state => selectors.currProjectSelector(state),
  currProject => {
    return currProject.history || [];
  }
);
